import { render } from "./Postcard.vue?vue&type=template&id=b755f600"
import script from "./Postcard.vue?vue&type=script&lang=js"
export * from "./Postcard.vue?vue&type=script&lang=js"
script.render = render

export default script